<div *ngIf="!isFilter" class="input-group"
     [style.height] ="sizeElement.height+'px'"
     (click)="showList()" #globalElement>
  <input type="text" class="form-control mx-0 {{style.inputClass}}"
         [style.height] ="sizeElement.height+'px'"
         [ngClass]="
          {
            'q-input-required': required === 'require',
            'q-input-novalid': required === 'no-valid',
            'q-input-disabled': disabled === true
          }"
         disabled
         aria-label="Small" aria-describedby="inputGroup-sizing" [ngModel]="value.text" #input>
  <div class="input-group-append mx-0 px-0" [style.height] ="sizeElement.height+'px'">
    <button [ngClass]="style.buttonClass" class="btn btn-outline buttonBo justify-content-end" id="inputGroup-sizing"><i class="fas fa-angle-down fa-lg"></i></button>
  </div>
</div>

<div *ngIf="isFilter" class="input-group"
     [style.height] ="sizeElement.height+'px'"
      #globalElement>
  <input type="text" class="form-control mx-0"
         [style.height] ="sizeElement.height+'px'"
         [ngClass]="style.inputClass"
         [placeholder]="placeHolder"
         aria-label="Small" aria-describedby="inputGroup-sizing" [(ngModel)]="filter" (keydown)="keydown($event)" (focus)="focus()" #input>

  <div class="input-group-append mx-0 px-0" [style.height] ="sizeElement.height+'px'" (click)="clickArrow()">
    <button [ngClass]="style.buttonClass" class="btn btn-outline buttonBo justify-content-end" id="inputGroup-sizing">
      <i class="fas fa-angle-down fa-lg"></i>
    </button>
  </div>
</div>

<ul *ngIf="!isFilter" class="listOptions px-0 position-absolute d-none" #listElement
    [ngClass]="style.listClass">
  <li *ngFor="let data of options; let i = index" [attr.value]="data.value" class="options w-100 pl-2" (click)="selectedValue(data, $event, i)">
    {{data.text}}
  </li>
</ul>

<ul *ngIf="isFilter" class="listOptions px-0 position-absolute d-none" (mouseover)="mouseOver()" (mouseout)="mouseOut()" #listElement
    [ngClass]="style.listClass">
  <li *ngFor="let data of options | grdFilter :{text: filter}; let i = index"
      [attr.value]="data.value"
      class="options w-100 pl-2"
      (click)="selectedValue(data, $event, i)"
      [ngClass]="{'q-list-select-search-default': i === compteur && !mouseIn}">
    {{data.text}}
  </li>
</ul>

